import React, { Suspense } from "react"

import type { ContextStoreProp } from "@future/context/store"

const RujiraHeaderContainer = React.lazy(
  () => import("../../../rujira/RujiraHeaderContainer"),
)

interface HeaderProps extends ContextStoreProp<"initial"> {
  levana: {
    includeAccount: boolean
  }
}

const Header = (props: HeaderProps): JSX.Element => {
  return (
    <Suspense>
      <RujiraHeaderContainer {...props} />
    </Suspense>
  )
}

export default Header
